<div>
    <app-tool-bar [title]="'Students'" [iconName]="'pi-user'" [isSearch]="true" [isDateFilter]="true"
        [selectedProducts]="selectedProducts" [isBulkAction]="true" [bulkActionItems]="bulkActionItems"
        [filtersOptions]="filtersOptions" (search)="handleSearch($event)" [exportItems]="exportItems" [isExport]="false"
        (ExportData)="export($event)" (dateFilter)="handleDateFilter($event)" (handleAdd)="isOpenAddDialog = true"
        [isAdd]="false" (resetDateFilter)="handleResetFilters()"></app-tool-bar>
</div>

<div class="p-4 overflow-auto h-[85vh]">
    <p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
        (onLazyLoad)="loadStudents($event)" [(selection)]="selectedProducts" [loading]="loading"
        [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
        <ng-template pTemplate="header">
            <tr style="height: 60px;">
                <th style="width: 4rem; border-top-left-radius: 10px; padding: 1rem;"><p-tableHeaderCheckbox /></th>
                <th *ngFor="let col of displayedColumns" style="padding: 1rem; font-weight: 600; font-size: 0.95rem;">
                    {{ col.header }}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer let-i="rowIndex" let-rowData>
            <tr style="height: 65px;">
                <td style="padding: 1rem;">
                    <p-tableCheckbox [value]="customer" />
                </td>
                <td *ngFor="let col of displayedColumns" style="padding: 1rem; vertical-align: middle;">
                    <ng-container [ngSwitch]="col.type">

                        <ng-container *ngSwitchCase="'student_roll_no'">
                            <div style="min-width: 100px;">
                                <a (click)="openStudentProfile(rowData)" class="text-blue-700 underline cursor-pointer">
                                    ID:- {{ rowData[col.field] || 'N/A' }}
                                </a>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'academic_year'">
                            {{ rowData.academicYear?.year_name || 'N/A' }}
                        </ng-container>

                        <ng-container *ngSwitchCase="'course'">
                            {{ rowData?.course?.name || 'N/A' }}
                        </ng-container>

                        <ng-container *ngSwitchCase="'department'">
                            {{ rowData?.department?.name || 'N/A' }}
                        </ng-container>

                        <ng-container *ngSwitchCase="'batch'">
                            <div style="min-width: 80px;">
                            {{ rowData.batche?.batch_name || 'N/A' }}
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'student_name'">
                            {{ getFullName(rowData) }}
                        </ng-container>

                        <ng-container *ngSwitchCase="'status'">
                            <div class="flex items-center gap-1 rounded-full px-5 py-[1px] w-fit min-w-[120px]  font-medium"
                                [style.borderWidth]="'2px'" [style.borderStyle]="'solid'"
                                [style.borderColor]="getStatusColor(rowData.status)"
                                [style.color]="getStatusColor(rowData.status)" style="font-weight: 500;">
                                <div style="margin-top: 2px;">
                                    <svg width="25px" height="25px" viewBox="0 0 32 32"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g [attr.stroke]="getStatusColor(rowData.status)" stroke-width="3"
                                            fill="none" stroke-linecap="round" stroke-linejoin="round">
                                            <path
                                                d="M12,13 C9.23857625,13 7,10.7614237 7,8 C7,5.23857625 9.23857625,3 12,3 C14.7614237,3 17,5.23857625 17,8 C17,10.7614237 14.7614237,13 12,13 Z M11.0150512,21 C9.04777237,21 6.37608863,21 3,21 C3.79921286,17.89195 6.4614209,16.2328962 10.9866241,16.0228387">
                                            </path>
                                            <polyline points="21.0037832 16.5969533 17 21 14.4906972 18.5114193">
                                            </polyline>
                                        </g>
                                    </svg>
                                </div>
                                {{
                                rowData.status || 'N/A'
                                }}
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'date'">
                            {{
                            rowData[col.field] | date: 'dd/MM/yyyy'
                            }}
                        </ng-container>

                      

                        <ng-container *ngSwitchCase="'number'">
                            {{
                            rowData[col.field] || 0
                            }}
                        </ng-container>

                        <!-- Handle Actions -->
                        <ng-container *ngSwitchCase="'actions'">
                            <div *ngIf="!loading" (click)="setLeadEditData(rowData)" class="flex justify-center">
                                <p-menu [tabindex]="undefined" #menu [model]="leadActionItems" [popup]="true"
                                    appendTo="body"></p-menu>
                                <button 
                                    (click)="menu.toggle($event)"
                                    class="inline-flex items-center justify-center w-9 h-9 rounded-full bg-gray-100 hover:bg-blue-50 hover:shadow-md cursor-pointer transition-all duration-200 ease-in-out">
                                    <i class="pi pi-ellipsis-h text-lg text-gray-700 hover:text-blue-600"></i>
                                </button>
                            </div>
                        </ng-container>

                        <!-- Default Case (Normal Field) -->
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] || 'N/A' }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="loading">
            <tr>
                <td colspan="3" class="text-center">
                    <p-progressSpinner></p-progressSpinner>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="displayedColumns.length + 1" class="no-data">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<!-- Delete Student Dialog -->
<p-dialog [modal]="true" *ngIf="isDeleteStudent" [(visible)]="isDeleteStudent"
    [breakpoints]="{ '1199px': '80vw', '575px': '90vw' }" closable="false" [style]="{ width: '40vw' }"
    [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isDeleteStudent">
        <app-delete-student [editLeadData]="editLeadData" (reload)="reloadDataTable()"
            (closeDialog)="isDeleteStudent = false"></app-delete-student>
    </ng-container>
</p-dialog>


<!-- Dialogs will be added here similar to admission component -->
 <p-dialog [modal]="true"  [(visible)]="isBulkUpdate" [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isBulkUpdate">
    <app-bulk-update [selectedProducts]="selectedProducts"
    [isStudent]="true"
        [title]="'Students'"
        [academicYears]="academicYears" [courses]="allCourses"
    [departments]="departments" [batches]="batches" [feeGroups]="feeGroups"
    [hostelCategories]="hostelCategories" [transportCategories]="transportCategories"
    [scholarshipTypes]="scholarshipTypes"
        (reload)="reloadDataTable()" (closeDialog)="isBulkUpdate = false" [courses]="allCourses"></app-bulk-update>
    </ng-container>
</p-dialog>
